import React, { Component } from 'react';
import {Button} from 'react-bootstrap';
import { handleFieldChange } from "../../../../Utils";
import FormOverlay from '../../../../components/FormOverlay';
import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from '../../../../components/SelectWrap';
import Icon from '../../../../components/Icon';
import countriesObj from "../../../../data/countries";

const countriesOptions = Object.assign({ D: 'DEFAULT' }, countriesObj);

class Form extends Component {
    constructor(props) {
        super(props);

        if(this.props.bid) {
            const { bid } = this.props;

            this.state = {
                country: bid.country,
                bid: bid.bid,
                update: true,
                confirm: false
            };
        }
        else {
            this.state = {
                country: '',
                bid: '',
                confirm: false
            };
        }

        this.handleConfirm = this.handleConfirm.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFieldChange = handleFieldChange.bind(this);
    }

    handleConfirm(event) {
        event.preventDefault();

        this.setState({ confirm: true });
    }

    handleSubmit() {
        this.props.onSubmit(Object.assign({}, this.state));
    }

    getConfirm() {
        if(this.state.confirm) {
            return (
                <FormOverlay onFormHide={this.props.onFormHide}>
                    <div className={'form-overlay-body'} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: 'auto', width: 'auto', padding: '2rem'}}>
                        <p>Are you sure that you want to set <strong>{this.state.bid * 1000}</strong> CPM in <strong>{countriesObj[this.state.country]}</strong></p>
                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                            <Button bsStyle={'danger'} onClick={this.props.onFormHide}>No</Button>
                            <Button bsStyle={'info'} onClick={this.handleSubmit}>Yes</Button>
                        </div>
                    </div>
                </FormOverlay>
            );
        }
    }

    getForm() {
        if(!this.state.confirm) {
            return (
                <FormOverlay onFormHide={this.props.onFormHide}>
                    <form onSubmit={this.handleConfirm} style={{ height: "auto", maxWidth: "600px" }}>
                        <SelectWrap
                            values={countriesOptions}
                            label="Country:"
                            name="country"
                            onChange={this.handleFieldChange}
                            value={this.state.country}
                        />
                        <FieldGroup
                            name="bid"
                            label="Bid:"
                            onChange={this.handleFieldChange}
                            value={this.state.bid}
                            type={'number'}
                            step={'0.001'}
                            max={'10'}
                            required
                        />

                        <Button className="pull-right" bsStyle="success" type="submit"><Icon name="floppy-o"/> Save</Button>
                    </form>
                </FormOverlay>
            );
        }
    }

    render() {
        return (
                <div>
                    {this.getConfirm()}
                    {this.getForm()}
                </div>

        );
    }
}

export default Form;


// WEBPACK FOOTER //
// ./src/scenes/AdkBids/components/Form/index.js